module.exports = __webpack_public_path__ + "static/img/icon-ens-item1.97e97c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-ens-item1.png
// module id = 6FEV
// module chunks = 21